import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const BackToTopButton = ({ elSelector, isScrollEl = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const scrollTop = () => {
    const el = document.querySelector(elSelector);
    if (el) {
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const behavior = prefersReducedMotion ? "auto" : "smooth";

      if (isScrollEl) {
        el.scrollTo({
          top: 0,
          behavior
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior
        });
      }

      window.setTimeout(
        () => {
          setIsVisible(false);
          if (!isScrollEl && typeof el.focus === "function") {
            el.focus({ preventScroll: true });
          }
        },
        prefersReducedMotion ? 0 : 400
      );
    }
  };

  useEffect(() => {
    const el = document.querySelector(elSelector);
    if (!el) return undefined;

    const scrollTarget = isScrollEl ? el : window;
    const scrollListener = () => setIsVisible(isTop100pxGoneOver(el, isScrollEl));

    scrollListener();
    scrollTarget.addEventListener("scroll", scrollListener, { passive: true });

    return () => {
      scrollTarget.removeEventListener("scroll", scrollListener);
    };
  }, [elSelector, isScrollEl]);

  if (!isVisible) return null;
  return (
    <button
      type="button"
      onClick={scrollTop}
      className={`ccw-back-to-top${isScrollEl ? "" : " ccw-back-to-top--fixed"}`}
      aria-label="Back to top"
    >
      <i className="fas fa-arrow-up" aria-hidden="true"></i>
      <span>Top</span>
    </button>
  );
};

BackToTopButton.propTypes = {
  elSelector: PropTypes.string.isRequired,
  isScrollEl: PropTypes.bool
};

export default BackToTopButton;

function isTop100pxGoneOver(el, isScrollEl) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }

  if (isScrollEl) {
    return el.scrollTop > 100;
  }

  return window.scrollY > 100;
}
